import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AuthenticationService } from '../../../../core/services/authentication.service';

@Component({
  selector: 'app-valores-container-viewer',
  templateUrl: './valores-container-viewer.component.html',
  styleUrls: ['./valores-container-viewer.component.css']
})
export class ValoresContainerViewerComponent implements OnInit {

  @Input() cssClassValues: string;
  @Input() cssClassShoppingCart: string;
  @Input() isInventoryView: boolean;
  @Input() hasPrestamoActivo = false;
  @Input() hasInsercionActiva = false;
  @Input() fullTextSummary;
  @Input() fieldsToShow = [];
  @Input() shoppingCart;
  @Input() hasActiveState = false;

  @Output() editObsPartialEvent = new EventEmitter<boolean>();
  @Output() removeElement = new EventEmitter<boolean>();
  @Output() createLoanEvent = new EventEmitter<boolean>();
  @Output() createInsertionEvent = new EventEmitter<boolean>();
  @Output() openObsPartialModalEvent = new EventEmitter<boolean>();

  userIsPermissionPartialLoan: boolean;

  constructor(
    private authService: AuthenticationService
  ) { }

  ngOnInit() {
    this.userIsPermissionPartialLoan = this.authService.permisosPartialLoan;
  }

  editObsPartial() {
    this.editObsPartialEvent.emit(true);
  }

  createLoan() {
    this.createLoanEvent.emit(true);
  }

  openObsPartialModal() {
    this.openObsPartialModalEvent.emit(true);
  }

  createInsertion() {
    this.createInsertionEvent.emit(true);
  }

  remove() {
    this.removeElement.emit(true);
  }

  getClassForValuesSize(value: { key: string; value: any; }) {
    if (!value.value) {
      return 'col-md-4';
    }

    const totalText = value.key.length + value.value.toString().length;

    return this.getTotalSizeClass(totalText);
  }
  private getTotalSizeClass(totalText: number): string {
    if (totalText <= 20) {
      return 'col-xs-12 col-sm-3 col-md-4 col-lg-4';
    }

    if (totalText <= 40) {
      return 'col-md-4';
    }

    if (totalText <= 60) {
      return 'col-xs-12 col-sm-12 col-md-11 col-lg-10';
    }

    if (totalText <= 80) {
      return 'col-md-8';
    }

    if (totalText <= 100) {
      return 'col-md-10';
    }

    return 'col-md-12';
  }

  getPercentage(length: number, value: { key: string; value: any; }): string {
    if (!value.value && length === value.key.length) {
      return '90%';
    }
    if (!value.value) {
      return '10%';
    }

    const totalLength = value.key.length + value.value.toString().length;

    const percentage = Math.round(length / totalLength * 100);


    return `${percentage}%`;
  }

}
